import React, {useCallback, useContext} from 'react';
import {Constants} from '../../view-constants.js';
import {articleOverviewStaticContext} from '../../ArticleOverviewStatic.jsx';
import {Button, Icon, Typography} from '@bonprix/design-system';
import {loadOnAccordeon, selectFilterLoadingbarStatus, selectLoadingbarStatus} from '../../LoaderSlice.jsx';
import {closeFilter} from '../../FilterSlice.jsx';
import {useDispatch, useSelector} from 'react-redux';
import {yieldToMain} from '../../ArticleOverviewHelper.js';
import {setFilterAjaxCall} from '../../AjaxCallSlice.jsx';
import {useTrinity} from '../../hooks/use-trinity.js';
import {useChangeFilters} from '@article-overview/components/hooks/use-change-filters.js';

function FilterLayer({hits, filterSubmit, btnRef, children}) {
    const {texts, browser} = useContext(articleOverviewStaticContext);
    const contentLoading = useSelector(selectLoadingbarStatus).status;
    const filterLoading = useSelector(selectFilterLoadingbarStatus).status;

    const dispatch = useDispatch();
    const {resetFilters} = useChangeFilters();

    const {sendClickBasic} = useTrinity();

    const isIphone =
        browser === Constants.SAFARI_BROWSER && navigator.userAgent.indexOf(Constants.USER_AGENT_IPHONE) !== -1;
    const groupsStyle = isIphone ? {height: window.innerHeight} : {};

    const submitButtonClick = useCallback(() => {
        yieldToMain(() => {
            dispatch(loadOnAccordeon());
            filterSubmit();
        });
    }, [filterSubmit]);

    const resetFilterClick = () => {
        yieldToMain(() => dispatch(loadOnAccordeon()));
        resetFilters(true);
        sendClickBasic('reset_filter', Constants.FILTER_VIEW_EVENT_VERSION);
    };

    // TODO: refactor - remove -small
    return (
        <div className="filter__mobile-layer" style={groupsStyle}>
            {renderHeadline()}
            <div className="filter__headline-line"></div>
            {children}
            {renderSubmitButton()}
        </div>
    );

    function renderHeadline() {
        const handleCloseFilter = () => {
            dispatch(setFilterAjaxCall(['', false]));
            dispatch(closeFilter());
            sendClickBasic('close_filter_sorting', Constants.FILTER_VIEW_EVENT_VERSION);
        };
        return (
            <div className="filter__headline-wrapper">
                <Typography component={'div'} variant={'bonprix-h6'}>
                    {texts.filter_title}
                </Typography>
                <div className="filter__headline-icon" onClick={handleCloseFilter}>
                    <Icon variant={'closer'} />
                </div>
            </div>
        );
    }

    function renderSubmitButton() {
        return (
            <div className="filter-layer__button-area" test-ref__filter-submit-button="" ref={btnRef}>
                <Button
                    onClick={submitButtonClick}
                    variant="primary"
                    loading={contentLoading}
                    disabled={filterLoading || hits === 0}
                    id="filter-submit-button"
                >
                    {texts.filter_submit} ({hits})
                </Button>
                <Button onClick={resetFilterClick} variant="secondary" disabled={filterLoading}>
                    {texts.filter_reset_sidesheet}
                </Button>
            </div>
        );
    }
}

export default React.memo(FilterLayer);
